import { Text } from '@noorden-insurtech/alba-design-system';
import { ChevronDown, ChevronUp } from 'lucide-react';
import type { PmePolicyEntity } from './map-policy-to-pme-view.util';
import { PmePolicyLivesTable } from './pme-policy-lives-table.component';
import { PmeReadOnlyField } from './pme-policy-section';

type Props = {
  policyId: string;
  entity: PmePolicyEntity;
  isOpen: boolean;
  onToggle: () => void;
};

/**
 * Card de um estipulante dentro de "Dados do Risco": Dados Básicos (leitura) +
 * a Lista de Vidas do bucket dele.
 *
 * A tabela só é montada quando o card está aberto — cada uma dispara a sua
 * própria consulta paginada ao BFF, e uma apólice pode ter vários
 * subestipulantes.
 */
export function PmePolicyStipulantCard({
  policyId,
  entity,
  isOpen,
  onToggle,
}: Props) {
  return (
    <div className='flex flex-col overflow-hidden rounded-xl border border-alba-gray-400'>
      <button
        type='button'
        className='flex w-full cursor-pointer items-center justify-between border-none bg-transparent px-4 py-4 text-left'
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <Text className='text-sm font-bold text-alba-black-500'>
          {entity.label}
        </Text>
        {isOpen ? (
          <ChevronUp
            className='h-5 w-5 shrink-0 text-alba-gray-600'
            strokeWidth={1.6}
          />
        ) : (
          <ChevronDown
            className='h-5 w-5 shrink-0 text-alba-gray-600'
            strokeWidth={1.6}
          />
        )}
      </button>

      {isOpen ? (
        <div className='flex flex-col gap-6 border-t border-alba-gray-400 px-4 py-4'>
          <div className='flex flex-col gap-4'>
            <Text className='text-base text-alba-black-500'>Dados Básicos</Text>
            <div className='grid grid-cols-1 gap-4 sm:grid-cols-2'>
              <PmeReadOnlyField
                label='CNPJ'
                required
                value={entity.basicData.document}
              />
              <PmeReadOnlyField
                label='Razão Social'
                required
                value={entity.basicData.socialName}
              />
              <PmeReadOnlyField
                label='Atividade Principal'
                value={entity.basicData.mainActivity}
                className='sm:col-span-2'
                trailingIcon={<ChevronDown className='h-4 w-4' />}
              />
              <PmeReadOnlyField label='E-mail' value={entity.basicData.email} />
              <PmeReadOnlyField
                label='Telefone'
                value={entity.basicData.phone}
              />
            </div>
          </div>

          <PmePolicyLivesTable
            policyId={policyId}
            targetId={entity.targetId}
            exportLabel={entity.basicData.socialName}
          />
        </div>
      ) : null}
    </div>
  );
}
